import { scenarioById } from '../data/scenarios';
import { tr } from '../i18n';
import { useDiagramStore } from '../state/store';

const legendItems = [
  ['event', 'event'], ['identity', 'identity'], ['commerce', 'commerce'], ['product', 'product'],
  ['audience', 'audience'], ['service', 'service'], ['analytics', 'analytics'], ['governance', 'governanceFlow'],
] as const;

export function StatusStrip({ reducedMotion }: { reducedMotion: boolean }) {
  const state = useDiagramStore();
  const scenario = scenarioById.get(state.scenarioId)!;
  const current = scenario.steps[state.stepIndex];
  const currentProgress = state.status === 'idle' ? 0 : Math.min(1, state.elapsedMs / current.durationMs);
  const totalProgress = ((state.stepIndex + currentProgress) / scenario.steps.length) * 100;
  return (
    <footer className="status-strip">
      <div className="legend-block"><span className="legend-title">{tr(state.language, 'legend')}</span><div className="legend-items">{legendItems.map(([category, label]) => <span key={category}><i className={`legend-line legend-line--${category}`} />{tr(state.language, label)}</span>)}</div></div>
      <div className="narrative-block" aria-live="polite">
        <div className="narrative-title"><span>{scenario.shortTitle[state.language]}</span><strong>{state.status === 'idle' ? tr(state.language, 'ready') : current.title[state.language]}</strong></div>
        <p>{state.status === 'idle' ? tr(state.language, 'disclaimer') : current.description[state.language]}</p>
        <div className="progress-track" aria-label={tr(state.language, 'progress')}><span style={{ width: `${totalProgress}%` }} /></div>
      </div>
      <div className="status-meta"><span>{state.status === 'paused' ? tr(state.language, 'paused') : state.status === 'complete' ? tr(state.language, 'complete') : `${state.stepIndex + 1}/${scenario.steps.length}`}</span><small>{reducedMotion ? tr(state.language, 'reduceMotion') : tr(state.language, 'disclaimer')}</small></div>
    </footer>
  );
}
